import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { useRef as C, useState as l, useEffect as I } from "react";
import { useTranslation as b } from "react-i18next";
import h from "../../icons/CheckmarkThin.js";
import k from "../../icons/Edit.js";
import "../../components/Breadcrumbs/index.js";
import d from "../../components/Button/index.js";
import "classnames";
import "reactjs-popup";
import "../../components/ThemeContext/index.js";
import "../../components/Modal/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "../../index-YV3Z4nmr.js";
import "react-dropzone";
import v from "../../fields/Input/index.js";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import "../../components/Tooltip/index.js";
const N = "forma-ui__document-name__root", E = "forma-ui__document-name__editButton", x = "forma-ui__document-name__editIcon", y = "forma-ui__document-name__submitButton", S = "forma-ui__document-name__submitIcon", T = "forma-ui__document-name__title", g = "forma-ui__document-name__input", t = {
  root: N,
  editButton: E,
  editIcon: x,
  submitButton: y,
  submitIcon: S,
  title: T,
  input: g
}, ct = ({ name: i, showNameInput: m, onSubmit: n }) => {
  const { t: r } = b(), s = C(null), [u, c] = l(""), [_, a] = l(!1);
  I(() => {
    i && c(i);
  }, [i]);
  const f = () => {
    a(!0), setTimeout(() => {
      var e;
      (e = s.current) == null || e.focus();
    });
  }, B = () => {
    a(!1), n && n(u);
  };
  return _ && m ? /* @__PURE__ */ p("div", { className: t.root, children: [
    /* @__PURE__ */ o(
      v,
      {
        name: "render_name",
        value: u,
        onChange: (e) => c(e.target.value),
        meta: { containerClass: t.input },
        ref: s
      }
    ),
    /* @__PURE__ */ o(
      d,
      {
        className: t.submitButton,
        viewStyle: "primary",
        iconClassName: t.submitIcon,
        icon: /* @__PURE__ */ o(h, {}),
        onClick: B,
        title: r("uikit:save")
      }
    )
  ] }, "save") : /* @__PURE__ */ p("div", { className: t.root, children: [
    /* @__PURE__ */ o("h1", { className: t.title, children: i }),
    m && /* @__PURE__ */ o(
      d,
      {
        className: t.editButton,
        viewStyle: "text",
        iconClassName: t.editIcon,
        icon: /* @__PURE__ */ o(k, {}),
        onClick: f,
        title: r("uikit:edit")
      }
    )
  ] }, "edit");
};
export {
  ct as default
};
